function getConversationMessages(conversation) {
  let messages = [];
  let currentNode = conversation.current_node;
  const mapping = conversation.mapping || {};

  while (currentNode) {
    const node = mapping[currentNode] || {};
    const message = node.message || null;
    const content = message ? message.content : null;
    let author = message ? (message.author ? message.author.role : '') : '';

    if (content && content.content_type === 'text') {
      const parts = content.parts || [];
      if (parts.length > 0 && parts[0].length > 0) {
        if (
          author !== 'system' ||
          (message.metadata ? message.metadata.is_user_system_message : false)
        ) {
          if (author === 'assistant') {
            author = 'ChatGPT';
          } else if (author === 'system') {
            author = 'Custom user info';
          }
          messages.push({ author: author, text: parts[0] });
        }
      }
    }
    currentNode = node.parent || null;
  }

  return messages.reverse();
}

// Define the function to convert conversations
export const convertConversations = (conversationsData) => {
  return conversationsData
    .filter((c) => c.update_time != null)
    .map((c) => ({
      ...c,
      updatedDate: new Date(c.update_time * 1000),
    }))
    .sort((a, b) => b.updateDate - a.updateDate)
    .map((c) => ({
      conversationId: c.conversation_id,
      title: c.title || 'Untitled',
      monthYear:
        c.updatedDate.toLocaleString('default', { month: 'long' }) +
        ' ' +
        c.updatedDate.getFullYear(),
      updatedDate: c.updatedDate.toISOString().slice(0, 19).replace('T', ' '),
      messages: getConversationMessages(c),
    }));
};
